// reviewList 페이지 온보딩 투어 스텝 정의
// - 항상 보이는 요소를 우선 타깃하고, 조건부 영역(상단고정/일괄바)은 "그것을 여는 트리거"를 가리켜 설명한다.
// - 리뷰 카드가 0건이면 카드 의존 스텝은 자동 제외한다.
import { buildSteps } from '../tourStep';

export function buildReviewListSteps(ctx, tour) {
  const hasCard = !!document.querySelector('.rl-card');

  return buildSteps([
    {
      id: 'welcome',
      emoji: '👋',
      title: '온리플 리뷰 관리에 오신 걸 환영해요!',
      text: '리뷰를 보고 관리하는 핵심 기능을 1분 안에 함께 둘러볼게요. 천천히 따라와 주세요 :)',
      attachTo: null,
    },
    {
      id: 'search',
      emoji: '🔍',
      title: '리뷰 검색 & 필터',
      text: '작성자·내용·기간 등으로 원하는 리뷰를 빠르게 찾을 수 있어요.',
      attachTo: { element: '.rl-search', on: 'bottom' },
    },
    {
      id: 'datePreset',
      emoji: '📅',
      title: '기간 빠른 선택',
      text: '오늘·7일·30일·이번달처럼 자주 쓰는 기간을 한 번에 지정해요.',
      attachTo: { element: '.rl-search__date-presets', on: 'bottom' },
    },
    {
      id: 'quickFilter',
      emoji: '⭐',
      title: '별점 · 상태 빠른 필터',
      text: '별점이나 <b>댓글 미작성</b>, <b>작성 후 대기</b> 같은 상태로 즉시 걸러볼 수 있어요.',
      attachTo: { element: '.rl-toolbar__quick-filters', on: 'bottom' },
    },
    {
      id: 'viewToggle',
      emoji: '🗂️',
      title: '보기 전환 & 상단 고정',
      text: '상세·간략·포토 보기를 바꿀 수 있어요. <b>상단고정만 보기</b>를 켜면 고정 리뷰를 상품별로 모아 <b>드래그로 순서</b>까지 바꿀 수 있어요.',
      attachTo: { element: '.rl-view-toggle', on: 'bottom' },
    },
    hasCard && {
      id: 'card',
      emoji: '🧾',
      title: '리뷰 카드 살펴보기',
      text: '작성자·별점·상품·내용을 한 카드에서 확인해요. 카드를 펼치면 더 자세히 볼 수 있어요.',
      attachTo: { element: '.rl-card', on: 'top' },
      beforeShow: '.rl-card',
    },
    hasCard && {
      id: 'reply',
      emoji: '💬',
      title: '답글 & AI 답글',
      text: '버튼 하나로 답글을 작성하거나, AI가 어울리는 답글을 제안해줘요.',
      attachTo: { element: '.rl-reply-btn', on: 'top' },
      beforeShow: '.rl-reply-btn',
    },
    hasCard && {
      id: 'photo',
      emoji: '🖼️',
      title: '사진 관리',
      text: '리뷰에 사진을 추가하거나 정리할 수 있어요.',
      attachTo: { element: '.rl-photo-add-btn', on: 'top' },
      beforeShow: '.rl-photo-add-btn',
    },
    hasCard && {
      id: 'mgmt',
      emoji: '⚙️',
      title: '리뷰 관리',
      text: '게시 상태 변경, <b>상단 고정</b>, 위젯 지정, 삭제를 여기서 처리해요.',
      attachTo: { element: '.rl-mgmt-panel', on: 'left' },
      beforeShow: '.rl-mgmt-panel',
    },
    {
      id: 'batch',
      emoji: '✅',
      title: '한 번에 일괄 처리',
      text: '여러 리뷰를 선택하면 화면 아래에 처리 바가 나타나, 게시 상태 변경·상단 고정을 한 번에 할 수 있어요.',
      attachTo: { element: '.rl-toolbar__select-all', on: 'bottom' },
    },
    {
      id: 'done',
      emoji: '🎉',
      title: '준비 끝!',
      text: '이제 자유롭게 사용해보세요. 다시 보고 싶으면 제목 옆 <b>?</b> 버튼을 누르면 언제든 다시 시작돼요.',
      attachTo: null,
    },
  ], tour);
}

export default buildReviewListSteps;
